module.exports = __webpack_public_path__ + "assets/img/5.729b3d55.jpg";